import React from 'react';
import styles from './PaymentInvoices.module.css';
import { fmtNum, fmtCurrAbbrev, fmtCurr } from './helpers';

const CARDS = [
  {
    key: 'totalInvoices',
    icon: '🧾',
    label: 'Total Invoices',
    sub: 'All time',
    colorClass: 'colorOr',
    fmt: fmtNum,
  },
  {
    key: 'thisWeekInvoices',
    icon: '📅',
    label: 'This Week',
    sub: 'Current billing week',
    colorClass: 'colorBl',
    fmt: fmtNum,
  },
  {
    key: 'totalSaleValue',
    icon: '💰',
    label: 'Total Sale Value',
    sub: 'This billing period',
    colorClass: 'colorGr',
    fmt: fmtCurr,
  },
  {
    key: 'kraveinFee',
    icon: '💰',
    label: 'Total Kravein Fee',
    sub: 'This billing period',
    colorClass: 'colorAm',
    fmt: fmtCurr,
  },
  {
    key: 'netPayout',
    icon: '💳',
    label: 'Net Payout',
    sub: 'After KRAVEiN fees',
    colorClass: 'colorTeal',
    fmt: fmtCurr,
  },
  {
    key: 'applicationFee',
    icon: '📊',
    label: 'Application Fee',
    sub: 'This billing period',
    colorClass: 'colorOr',
    fmt: fmtCurr,
  },
  {
    key: 'deliveryFee',
    icon: '🚚',
    label: 'Delivery Fee',
    sub: 'This billing period',
    colorClass: 'colorBl',
    fmt: fmtCurr,
  },
  {
    key: 'kraveinCharges',
    icon: '⚡',
    label: 'KRAVEiN Charges',
    sub: 'This billing period',
    colorClass: 'colorAm',
    fmt: fmtCurr,
  },
  {
    key: 'creditCardFees',
    icon: '💳',
    label: 'Kravein Payment Gateway Fee',
    sub: 'This billing period',
    colorClass: 'colorOr',
    fmt: fmtCurr,
  },
  {
    key: 'kraveinPayout',
    icon: '💸',
    label: 'KRAVEiN Payout',
    sub: 'This billing period',
    colorClass: 'colorTeal',
    fmt: fmtCurr,
  },
];

const InvoiceStatCards = ({
  status,
  totalInvoices,
  thisWeekInvoices,
  totalSaleValue,
  netPayout,
  applicationFee,
  kraveinFee,
  deliveryFee,
  kraveinCharges,
  creditCardFees,
  kraveinPayout,
}) => {
  const values = {
    totalInvoices,
    thisWeekInvoices,
    totalSaleValue,
    netPayout,
    applicationFee,
    kraveinFee,
    deliveryFee,
    kraveinCharges,
    creditCardFees,
    kraveinPayout,
  };
  const isLoading = status === 'idle' || status === 'loading';

  return (
    <div className={styles.statGrid}>
      {CARDS.map(({ key, icon, label, sub, colorClass, fmt }, i) => (
        <div
          key={key}
          className={styles.statCard}
          style={{ animationDelay: `${i * 50}ms` }}
        >
          <div className={styles.statIcon}>{icon}</div>
          {isLoading ? (
            <div
              className={styles.statSkeleton}
              style={{ width: '70%', marginBottom: 8 }}
            />
          ) : (
            <div className={`${styles.statValue} ${styles[colorClass]}`}>
              {fmt(values[key])}
            </div>
          )}
          <div className={styles.statLabel}>{label}</div>
          <div className={styles.statSub}>{sub}</div>
        </div>
      ))}
    </div>
  );
};

export default InvoiceStatCards;
